import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';
import ReactSVG from 'react-svg';

import { PageGrid } from '../shared/CommonStyledComponents';
import NextPageLink from '../shared/NextPageLink';

import webAppsApis from '../assets/images/services/web-apps-apis.svg';
import mobileApps from '../assets/images/services/mobile-apps.svg';
import customSoftware from '../assets/images/services/custom-software.svg';
import websites from '../assets/images/services/websites.svg';
import anyStartupIdea from '../assets/images/services/any-startup-idea.svg';
import ourWorkSideLink from '../assets/images/sideLinks/our_work_side_link.svg';


const ServicesRow = styled(Row)`
  height: 100%;
  padding-top: 20px;
  padding-bottom: 28px;
  width: 88%;
  padding-left: 3px;

  @media (max-width: 64em) {
    width: auto;
  }
`;

const ServicesColumn = styled(Col)`
  @media (max-width: 64em) {
    margin-bottom: 17px;
  }
`;

const ServicesBox = styled.div`
  background-color: #80cbc3;
  height: 100%;
  text-align: center;
  padding: 1vw;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
`;

const ServiceTitle = styled.h2`
  font-size: 1.5vw;

  @media (max-width: 64em) {
    font-size: 4.5vw;
  }
`;

const ServiceImage = styled(ReactSVG)`
  width: 10vw;
  margin: auto;

  @media (max-width: 64em) {
    width: 23vw;
  }
`;

const ServiceText = styled.p`
  font-size: 1vw;

  @media (max-width: 64em) {
    font-size: 4vw;
    padding: 15px;
    padding-bottom: 0;
  }
`;

const Services = () => (
  <PageGrid id="services">
    <ServicesRow>
      <ServicesColumn xs={12} sm={12} md>
        <ServicesBox>
          <div>
            <ServiceTitle>Web Apps / API’s</ServiceTitle>
            <ServiceImage
              className="service-images"
              path={webAppsApis}
            />
            <ServiceText>
              A web application is a software living on the internet. For example, Facebook,
              Twitter, Ebay, PayPal, these are all web applications. We can build many
              types of web applications ranging from simple e-commerce apps to complex
              and unique applications. We can also build APIs for those applications
              so that external applications like mobile apps can connect to the application
              with ease.
            </ServiceText>
          </div>
        </ServicesBox>
      </ServicesColumn>
      <ServicesColumn xs={12} sm={12} md>
        <ServicesBox>
          <div>
            <ServiceTitle>Mobile Apps</ServiceTitle>
            <ServiceImage
              className="service-images"
              path={mobileApps}
            />
            <ServiceText>
              We are capable of creating both iOS and Android applications. The technologies
              we use allow us to build very reliable applications with both
              web and native components. I&apos;m not talking about hybrid apps
              which run in a web view. We use web technologies to write the
              application but at the end, they get compiled into native code
              which allows us to build really great apps.
            </ServiceText>
          </div>
        </ServicesBox>
      </ServicesColumn>
      <ServicesColumn xs={12} sm={12} md>
        <ServicesBox>
          <div>
            <ServiceTitle>Custom software</ServiceTitle>
            <ServiceImage
              className="service-images"
              path={customSoftware}
            />
            <ServiceText>
              If you need a software for your organisation (For example, inventory
              control systems, CRM systems, HR systems, and unique applications
              which no one has ever touched) we can build complex systems for you.
              This might include several admin portals, client portals, mobile apps,
              desktop apps, and many different components required to solve your problem.
            </ServiceText>
          </div>
        </ServicesBox>
      </ServicesColumn>
      <ServicesColumn xs={12} sm={12} md>
        <ServicesBox>
          <div>
            <ServiceTitle>Websites</ServiceTitle>
            <ServiceImage
              className="service-images"
              path={websites}
            />
            <ServiceText>
              Aside from the complex stuff, we also build simple websites. If you need a website
              for your company, yourself, your cause, etc we can help you. After
              extensively researching your need, we will design and build unique websites
              from scratch. We can use fancy animations and stuff or use simple designs
              to make your website stand out from the rest.
            </ServiceText>
          </div>
        </ServicesBox>
      </ServicesColumn>
      <ServicesColumn xs={12} sm={12} md>
        <ServicesBox>
          <div>
            <ServiceTitle>Your idea...</ServiceTitle>
            <ServiceImage
              className="service-images"
              path={anyStartupIdea}
            />
            <ServiceText>
              Let&apos;s say you have a great idea but don&apos;t have the technical skills to do
              it. We can help you with that. We will not only just build what you want, we will
              also guide you through the hard process of forming a startup and becoming
              successful. We are always ready to go a step forward and help you. Not
              just build a software and step aside. We love crazy ideas. If you have something
              like that, we can help you change the world with it!
            </ServiceText>
          </div>
        </ServicesBox>
      </ServicesColumn>
    </ServicesRow>

    <NextPageLink
      color="98c3f7"
      image={ourWorkSideLink}
      text="OUR WORK"
    />
  </PageGrid>
);

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js